import React, { Component } from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { CardHeader, Card, CardContent, Typography } from '@material-ui/core'
import { blue800, white } from '../../../../MaterialColorPicker/colors'
import { TABLA_MOVIMIENTOS_DE_MERCADERIA } from '../../../../../config/tables'

export class TablaMovimientosMercaderiaView extends Component {
  render () {
    return (
      <>
        <MuiTable id={TABLA_MOVIMIENTOS_DE_MERCADERIA} />
        <br />
        <div className='row justify-content-end'>

          <Card style={{ width: '18rem', marginRight: 20 }}>
            <CardHeader style={{ background: blue800, color: white }}
              title='Total'
            />
            <CardContent style={{ padding: '0 0 0 0' }}>
              <Typography variant='h5'>
                {this.props.total} Tns
              </Typography>
            </CardContent>
          </Card>
        </div>
      </>
    )
  }
}
